// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"272":"c4a9e2c2","371":"ebbf1212","928":"7437de33"}[chunkId] + ".chunk.js";
};